// Lightweight analytics helper. Fires a GA4 event when gtag is available
// (the site owner can add their GA4 measurement script in index.html
// independently; this helper will no-op safely until then).
export function trackBookClick(source) {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "book_click", { service: source });
    }
    // Always push to dataLayer too (works with GTM if they prefer it)
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: "book_click", service: source });
    }
  } catch (e) {
    // Never let analytics break a click-through
    // eslint-disable-next-line no-console
    console.debug("track book click failed", e);
  }
}
